import AXIOS from "services/axios";

export const handleBulkUpload = async (bulkMappingId, file, platform) => {
  const response = { status: null, message: null, error: null, issues: [] };

  if (!bulkMappingId) {
    response.status = 400;
    response.error = "Invalid SMAR Group ID for bulk upload";
    return response;
  }
  try {
    const formData = new FormData();

    const keyMap = {
      instagram: "insta_handles",
      twitter: "handles",
      facebook: "pages",
      youtube: "channels",
    };

    const fileKey = keyMap[platform] || "file";

    formData.append(fileKey, file);

    const { data } = await AXIOS.patch(
      `${process.env.REACT_APP_API_PATH}/smargroup/bulk-smargroup-mapping/${bulkMappingId}`,
      formData,
      {
        headers: { "Content-Type": "multipart/form-data" },
      }
    );

    response.status = 200;
    response.message = data.message || "Uploaded Successfully";
  } catch (err) {
    const errorData = err.response?.data;

    response.status = err.response?.status || 500;
    response.message = errorData?.message || null;
    response.error =
      errorData?.error?.message || errorData?.error || err.message;
    response.issues = errorData?.issues || [];
  }

  return response;
};

export const getSmarList = async (
  pageCount,
  platform,
  searchSmarGroup,
  region_type,
  category,
  object_id,
  party
) => {
  const response = { data: null, error: null };

  try {
    const queryParams = [];

    if (region_type) queryParams.push(`region_type=${region_type}`);
    if (category) queryParams.push(`smargroup_category=${category}`);
    if (object_id) queryParams.push(`object_id=${object_id}`);
    if (pageCount > 1) queryParams.push(`page=${pageCount}`);
    if (platform) queryParams.push(`platform=${platform}`);
    if (searchSmarGroup) queryParams.push(`group_name=${searchSmarGroup}`);
    //if (party) queryParams.push(`political_party=${party}`);
    const queryString =
      queryParams.length > 0 ? `?${queryParams.join("&")}` : "";

    const { data } = await AXIOS.get(
      `${process.env.REACT_APP_API_PATH}/smargroup/${queryString}`
    );
    response.data = data;
  } catch (err) {
    response.error = err.response;
  }

  return response;
};

export const getSmarDetail = async (id) => {
  const response = { data: null, error: null };
  try {
    const { data } = await AXIOS.get(
      `${process.env.REACT_APP_API_PATH}/smargroup/${id}/`
    );
    response.data = data;
  } catch (err) {
    response.error = err.response;
  }
  return response;
};

export const addSmarGroup = async (
  id,
  group_name,
  smargroup_category,
  smargroup_sub_category,
  platform,
  state,
  country,
  pages,
  action,
  region_type
) => {
  let object_id = "";
  if (region_type.name.toLowerCase() === "state") {
    object_id = state.id;
  } else if (
    region_type.name.toLowerCase() === "nation" ||
    region_type.name.toLowerCase() === "nation"
  ) {
    object_id = country.id;
  }
  const response = {
    status: null,
    message: null,
  };
  let obj;
  if (platform?.name.toLowerCase() === "youtube") {
    obj = {
      group_name: group_name,
      smargroup_category: smargroup_category,
      smargroup_sub_category: smargroup_sub_category,
      platform: platform.id,
      pages: [],
      handles: [],
      insta_handles: [],
      ytchannels: pages,
      country: country.id,
      object_id: object_id,
      region_type: region_type.id,
    };
  } else if (platform?.name.toLowerCase() === "instagram") {
    obj = {
      group_name: group_name,
      smargroup_category: smargroup_category,
      smargroup_sub_category: smargroup_sub_category,
      platform: platform.id,
      pages: [],
      handles: [],
      insta_handles: pages,
      ytchannels: [],
      country: country.id,
      object_id: object_id,
      region_type: region_type.id,
    };
  } else if (platform?.name.toLowerCase() === "twitter") {
    obj = {
      group_name: group_name,
      smargroup_category: smargroup_category,
      smargroup_sub_category: smargroup_sub_category,
      platform: platform.id,
      pages: [],
      handles: pages,
      insta_handles: [],
      ytchannels: [],
      country: country.id,
      object_id: object_id,
      region_type: region_type.id,
    };
  } else {
    obj = {
      group_name: group_name,
      smargroup_category: smargroup_category,
      smargroup_sub_category: smargroup_sub_category,
      platform: platform.id,
      pages: pages,
      handles: [],
      ytchannels: [],
      insta_handles: [],
      country: country.id,
      object_id: object_id,
      region_type: region_type.id,
    };
  }

  try {
    if (action === "edit") {
      const { data } = await AXIOS.patch(
        `${process.env.REACT_APP_API_PATH}/smargroup/${id}/`,
        obj
      );
      response.status = data.status;
      response.message = data.message;
    } else {
      const { data } = await AXIOS.post(
        `${process.env.REACT_APP_API_PATH}/smargroup/`,
        obj
      );
      response.status = data.status;
      response.message = data.message;
    }
  } catch (err) {
    response.error = err.response.data.message;
    response.status = err.response.status;
    response.message = err.response.data[0];
  }
  return response;
};

export const handlePageDelete = async (id, newPages) => {
  const response = {
    status: null,
    message: null,
  };
  try {
    const { data } = await AXIOS.put(
      `${process.env.REACT_APP_API_PATH}/smargroup/update/relation/group/${id}`,
      {
        page_ids: newPages,
      }
    );
    response.status = data.status;
    response.message = data;
  } catch (err) {
    response.error = err.response;
  }
  return response;
};

export const getSmarGroupDetails = async (id) => {
  const response = { result: null, error: null };
  try {
    const { data } = await AXIOS.get(
      `${process.env.REACT_APP_API_PATH}/smargroup/details/${id}`
    );
    response.result = data;
  } catch (err) {
    response.error = err.response;
  }
  return response;
};
